import { h } from 'preact';
import * as BaseComp from 'components/bolt/gallery/gallery.js';
import { sortObjectByOrder } from 'utils/utils';
import { getDynamicData } from 'utils/bolt/dynamicData';
import Store from 'store/store';

export default class Gallery extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount?.();

		const { appData } = Store.get();
		if (appData?.options?.cmsManaged) {
			const { id } = this.props;

			switch (id) {
				case 'gallery':
					await this.loadCustomData(await getDynamicData('about-us'));
					break;
			}
		}
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) return;

		const { appData } = Store.get();
		if (!appData?.options?.cmsManaged) return;

		const galleryArray = dynamicData.gallery?.content || dynamicData.gallery || dynamicData;

		if (!Array.isArray(galleryArray)) return;

		this.dynamicData = galleryArray.reduce((acc, image, i) => {
			const key = image.name || image.title || `image-${i}`;
			acc[key] = {
				order: i + 1,
				name: image.name || image.title,
				desktopSrc: image.file,
				tabletSrc: image.file,
				mobileSrc: image.file,
				annotation: image.annotation || '',
				alt: image.altText || '',
			};
			return acc;
		}, {});

		const sortedImages = sortObjectByOrder(this.dynamicData, (value, key) => ({
			...value,
			key,
		}));

		this.setState({ images: sortedImages });
	}

}